import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=39408933&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/myz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39408933')) {
      api.createRecord('39408933', component.options)
    } else {
      api.reload('39408933', component.options)
    }
    module.hot.accept("./pagination.vue?vue&type=template&id=39408933&", function () {
      api.rerender('39408933', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/vue/web/page/components/pagination.vue"
export default component.exports